import React from 'react';
import PropTypes from 'prop-types';
import BaseComponent from './BaseComponent';
import Answer from './Answer';
import Media from '../CommonSet/Media';

class Body extends BaseComponent {
    constructor(props) {
        super(props);
        this.handleAnswerClick = this.handleAnswerClick.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.index !== this.props.index) {
            this.quizBody.scrollTop = 0;
        }
    }

    handleAnswerClick(value, isCheck) {
        this.props.onSelectAnswer({
            value,
            isCheck,
            index: this.props.index,
        });
    }

    createAnswer() {
        const answerCompSet = this.props.questionData.map((obj, idx) => (
            <Answer
                key={idx}
                value={idx}
                index={this.props.index}
                text={obj.text}
                isCorrect={obj.isCorrect}
                isCheck={this.props.answerData[idx]}
                onAnswerClick={this.handleAnswerClick}
            />
        ));

        return answerCompSet;
    }

    createRenderView(content) {
        const wrapper = Entry.createElement('div');
        if (content) {
            $('body').append(wrapper);
            wrapper.addClass(this.Styles.editorBlock);
            wrapper.addClass('blocks');
            wrapper.contentEditable = false;
            $(wrapper).attr('block', content);
            const renderView = new Entry.RenderView(wrapper, 'LEFT_MOST');
            renderView.changeCode(new Entry.Code(JSON.parse(content)), true);
            $(wrapper).detach();
        }
        return wrapper;
    }

    createContent() {
        const prefixText = `<strong>${this.getLang('General.questions')} ${this
            .props.index + 1}) </strong>`;
        let content = '';

        if (this.props.data.content) {
            content = this.props.data.content.replace(
                /\*\*\*.*?\*\*\*/gim,
                (item) => {
                    let block = item.substring(3, item.lastIndexOf('***'));
                    return $('<div>')
                        .append(this.createRenderView(block))
                        .html();
                }
            );
        }

        return {
            __html: prefixText + content,
        };
    }

    render() {
        return (
            <div
                className={this.Styles.quizBody}
                ref={(dom) => {
                    this.quizBody = dom;
                }}
            >
                <div
                    className={this.Styles.content}
                    dangerouslySetInnerHTML={this.createContent()}
                />
                <Media media={this.props.data.media} />
                <div className={this.Styles.answerData}>
                    {this.createAnswer()}
                </div>
            </div>
        );
    }
}

Body.displayName = 'QuizBody';
Body.propTypes = {
    index: PropTypes.number.isRequired,
    data: PropTypes.object.isRequired,
    answerData: PropTypes.object.isRequired,
    isRandom: PropTypes.bool.isRequired,
    isMultiChoice: PropTypes.bool.isRequired,
    onSelectAnswer: PropTypes.func.isRequired,
};
Body.defaultProps = {
    answerData: {},
    data: {},
    isRandom: false,
    isMultiChoice: false,
};

export default Body;



// WEBPACK FOOTER //
// ./components/QuizSet/Body.js